import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { UserRedirectsEnum } from '@services/UserService';
import { MovementsMenuTypesEnum } from '@services/MovimentationService';

import { MovementServiceTypeEnum } from '../enums';
import type { MovementMenuService } from '../types';

export const ACTIVE_CONTRACT_SERVICES: MovementMenuService[] = [
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="medical-b2b-add-group"
        size={32}
      />
    ),
    title: 'Inclusão de dependentes',
    description:
      'Adicione dependentes (recém-nascidos, filhos, cônjuge etc) a um titular ativo',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_INCLUDE_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenIncludeDependent,
        title: 'Inclusão de dependentes',
        description: 'Inclua dependentes em um titular ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_BIRTH_INCLUDE_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenBirthIncludeDependent,
        title: 'Inclusão de filhos/recém-nascidos',
        description:
          'Inclua filhos/recém-nascidos como dependentes de um titular ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_MARRIAGE_INCLUDE_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenMarriageIncludeDependent,
        title: 'Inclusão de cônjuge/recém-casado',
        description:
          'Inclua recém-casado/cônjuge como dependentes de um titular ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_INCLUDE_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenCancelIncludeDependent,
        title: 'Cancelar pedido de inclusão de dependentes',
        description:
          'Cancele pedidos de inclusão de dependentes antes da ativação da vida',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="actions-b2b-list-status"
        size={32}
      />
    ),
    title: 'Autorização de pedidos pendentes',
    description: 'Peça a reanálise de vidas com pendências já regularizadas.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_INCLUDE_PENDING_REQUEST_AUTHORIZATION,
        enum: MovementsMenuTypesEnum.MovementScreenIncludePendingRequestAuthorization,
        title: 'Gerenciar pedidos de inclusão',
        description: 'Acesse a lista de pedidos de inclusão com pendências',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_EXCLUDE_PENDING_REQUEST_AUTHORIZATION,
        enum: MovementsMenuTypesEnum.MovementScreenExcludePendingRequestAuthorization,
        title: 'Gerenciar pedidos de exclusão',
        description: 'Acesse a lista de pedidos de exclusão com pendências',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="actions-b2b-person-edit"
        size={32}
      />
    ),
    title: 'Alteração de dados',
    description:
      'Altere informações como: plano, unidade, nome, endereço e dados pessoais.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_PLAN_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenChangePlanBeneficiary,
        title: 'Alterar plano de titular ativo',
        description: 'Altere o plano de um titular ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_UNIT_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenChangeUnitBeneficiary,
        title: 'Alterar unidade de titular ativo',
        description: 'Altere a unidade cadastrada de um titular ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_DATA_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenChangeDataBeneficiary,
        title: 'Alterar dados cadastrais de titular ativo',
        description: 'Altere dados cadastrais de titulares ativos',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_CHANGE_DATA_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenCancelChangeDataBeneficiary,
        title: 'Cancelar pedido de alteração de dados de titular',
        description: 'Cancele pedidos de alteração de dados de um titular',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_INCLUDE_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenChangeIncludeDependent,
        title: 'Alterar dados de novos dependentes',
        description: 'Altere dados de novos dependentes de titulares ativos',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CHANGE_DATA_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenChangeDataDependent,
        title: 'Alterar dados cadastrais de dependente ativo',
        description: 'Altere dados cadastrais de dependentes ativos',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_CHANGE_DATA_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenCancelChangeDataDependent,
        title: 'Cancelar pedido de alteração de dados de dependente',
        description: 'Cancele pedidos de alteração de dados de um dependente',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="medical-b2b-person-cancel"
        size={32}
      />
    ),
    title: 'Exclusão',
    description: 'Solicite a exclusão de titular ou dependente ativo.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_NEW_PRE_CANCELLATION_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenNewPreCancellationBeneficiary,
        title: 'Exclusão de titular',
        description: 'Solicite a exclusão de um titular ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_PRE_CANCELLATION_BENEFICIARY,
        enum: MovementsMenuTypesEnum.MovementScreenCancelPreCancellationBeneficiary,
        title: 'Cancelar pedido de exclusão de titular',
        description: 'Cancele o pedido de exclusão de um titular ativo.',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_NEW_PRE_CANCELLATION_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenNewPreCancellationDependent,
        title: 'Exclusão de dependentes',
        description: 'Solicite a exclusão de um dependente ativo',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_PRE_CANCELLATION_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenCancelPreCancellationDependent,
        title: 'Cancelar pedido de exclusão de dependentes',
        description: 'Cancele o pedido de exclusão de um dependente ativo.',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="actions-b2b-swap-horizontal"
        size={32}
      />
    ),
    title: 'Transferência',
    description:
      'Solicite a transferência de beneficiários para outros contratos coligados.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_INCLUDE_TRANSFER,
        enum: MovementsMenuTypesEnum.MovementScreenIncludeTransfer,
        title: 'Novo pedido de transferência',
        description: 'Solicite a transferência de beneficiários',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_TRANSFER,
        enum: MovementsMenuTypesEnum.MovementScreenCancelTransfer,
        title: 'Cancelar pedido de transferência',
        description: 'Cancele o pedido de transferência de beneficiários',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="actions-b2b-account-child-outline"
        size={32}
      />
    ),
    title: 'Controle de maioridade',
    description: 'Consulte/Exclua beneficiários com maioridade contratual',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_MAJORITY_CONTROL_PRE_CANCELLATION_DEPENDENT,
        enum: MovementsMenuTypesEnum.MovementScreenMajorityControlPreCancellationDependent,
        title: '',
        description: '',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="actions-b2b-pause-octagon-outline"
        size={32}
      />
    ),
    title: 'Sustar pedido de exclusão',
    description: 'Suste pedidos de exclusão de um titular ou dependente ativo.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_SUSPEND_PRE_CANCELLATION,
        enum: MovementsMenuTypesEnum.MovementScreenSuspendPreCancellation,
        title: '',
        description: '',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.ACTIVE_CONTRACT,
    primary: false,
    icon: (
      <Icon
        color={NEW_COLORS.SECONDARY[500]}
        name="navigation-b2b-account-cog-outline"
        size={32}
      />
    ),
    title: 'Suspender e reativar atendimento',
    description: 'Gerencie o status de atendimento de beneficiários.',
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_SUSPEND_MEDICAL_CARE,
        enum: MovementsMenuTypesEnum.MovementScreenSuspendMedicalCare,
        title: 'Suspender atendimento',
        description: 'Solicite a suspensão de atendimento de beneficiários',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_REACTIVATE_MEDICAL_CARE,
        enum: MovementsMenuTypesEnum.MovementScreenReactivateMedicalCare,
        title: 'Reativar atendimento',
        description: 'Solicite a reativação de atendimento de beneficiários',
      },
      {
        id: UserRedirectsEnum.MOVEMENT_SCREEN_CANCEL_REQUEST_SUSPENDED_BENEFICIARIES,
        enum: MovementsMenuTypesEnum.MovementScreenCancelRequestSuspendedBeneficiaries,
        title: 'Cancelar pedido de suspensão',
        description: 'Cancele o pedido de suspensão de beneficiários',
      },
    ],
  },
];
